export default "__VITE_ASSET__f69ad5ca__"